import React from "react";
import styled from "styled-components";
// Components
import { useInView } from "react-intersection-observer";
import FullButton from "../Buttons/FullButton";
import ServiceBox from "../Elements/ServiceBox";
// Assets
import AddImage1 from "../../assets/img/creativity1.avif";
import AddImage2 from "../../assets/img/creativity2.avif";
import AddImage3 from "../../assets/img/creativity3.avif";
import AddImage4 from "../../assets/img/creativity4.avif";
import { Link } from "react-scroll";

export default function Services() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.0 });
  return (
    <Wrapper id="services" ref={ref}
      className={`container ${inView ? "animate__animated animate__slideInRight" : "opacity-0"}`}>
      {/*<div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div>*/}
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold animated-gradient-text">Our Awesome Services</h1>
            <p className="font13">
              At Eonx, we bring cutting-edge solutions to empower businesses with the latest in technology.
              <br />
              Our expertise spans across multiple domains, ensuring seamless digital transformation tailored to your needs.            </p>
          </HeaderInfo>
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="websiteDevelopment"
                title="Website Development"
                subtitle="From dynamic websites to powerful e-commerce platforms, we craft intuitive and responsive digital experiences. Our solutions are tailored for performance, security, and scalability, ensuring your online presence stands out."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="appDevelopment"
                title="App Development"
                subtitle="We design and develop mobile applications that redefine user experiences. Whether it's iOS, Android, or cross-platform, we build high-performance apps with a focus on usability, innovation, and seamless integration."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="cloudInfrastructure"
                title="Cloud Infrastructure"
                subtitle="Unlock the full potential of the cloud with our expert infrastructure services. From migration to optimization, we ensure your business operates efficiently with secure, scalable, and cost-effective cloud solutions."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="artificialIntelligence" title="Artificial Intelligence (AI)" subtitle="Leverage AI-driven insights, automation, and machine learning to enhance decision-making and operational efficiency. We develop intelligent solutions that transform businesses with smarter processes and predictive analytics." />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="blockchainTechnology" title="Blockchain Technology" subtitle="Secure, transparent, and decentralized—our blockchain solutions help businesses streamline operations, enhance security, and innovate in finance, supply chain, and beyond." />
            </ServiceBoxWrapper>

          </ServiceBoxRow>
        </div>
        <div ref={ref}
          className={`lightBg ${inView ? "animate__animated animate__slideInLeft" : "opacity-0"}`}>
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <h4 className="font15 semiBold">A few words about company</h4>
                <h2 className="font40 extraBold animated-gradient-text">A Study of Creativity</h2>
                <p className="font12">
                  At EonX, we believe in the power of innovation and creativity to transform businesses. Our expertise in website development, app development, and cloud services allows us to build cutting-edge solutions tailored to your needs.
                </p>
                <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                  <div style={{ width: "190px" }}>
                  <Link to="contact" smooth={true}><FullButton title="Get Started" /></Link>
                  </div>
                  <div style={{ width: "190px", marginLeft: "15px" }}>
                      <Link to="contact" smooth={true}><FullButton title="Contact Us" border /></Link>
                  </div>
                </ButtonsRow>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                      <img src={AddImage1} alt="office" />
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                      <img src={AddImage2} alt="office" />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                      <img src={AddImage3} alt="office" />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                      <img src={AddImage4} alt="office" />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  margin-right: 5%;
  padding: 80px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;